// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary

interface DescriptiveErrorOptions extends ErrorOptions {
  description?: string;
  statusCode?: number;
}

class DescriptiveError<T extends DescriptiveErrorOptions> extends Error {
  description?: string;
  statusCode?: number;

  constructor(message?: string, options?: T) {
    super(message, options);
    this.description = options?.description;
    this.statusCode = options?.statusCode;
  }
}

// eslint-disable-next-line
interface AuthenticationErrorOptions extends DescriptiveErrorOptions {}

export class AuthenticationError extends DescriptiveError<AuthenticationErrorOptions> {}

// eslint-disable-next-line
interface ConfigurationErrorOptions extends DescriptiveErrorOptions {}

export class ConfigurationError extends DescriptiveError<ConfigurationErrorOptions> {}
